// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AjLqccDS_q82ihpFdIoY{max-width:432px}.pQFMLqgVTYmgsnVTEUtb{display:flex;max-width:100%}`, "",{"version":3,"sources":["webpack://./src/pages/clients/ui/shared/TeamsSelectField/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CAGF,sBACE,YAAA,CACA,cAAA","sourcesContent":[".teamsSelectPlaceholder {\n  max-width: 432px;\n}\n\n.teamChip {\n  display: flex;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamsSelectPlaceholder": `AjLqccDS_q82ihpFdIoY`,
	"teamChip": `pQFMLqgVTYmgsnVTEUtb`
};
export default ___CSS_LOADER_EXPORT___;
